import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) {
  var t = _Object$keys(e);
  if (_Object$getOwnPropertySymbols) {
    var o = _Object$getOwnPropertySymbols(e);
    r && (o = _filterInstanceProperty(o).call(o, function (r) {
      return _Object$getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import _Object$values from "@babel/runtime-corejs3/core-js-stable/object/values";
import _replaceAllInstanceProperty from "@babel/runtime-corejs3/core-js/instance/replace-all";
import isUndefined from "lodash/isUndefined";
import { getConfigValue } from "@jutro/config";
import { warning } from "@jutro/logger";
import { joinUrl } from "@jutro/platform";
var testcafePolyfill = function (defaultUrl) {
    return !!window["%hammerhead%"] ? "" : defaultUrl;
  },
  isServiceWorkerDisabled = function () {
    var _window$location,
      _window,
      _ref = null !== (_window$location = null === (_window = window) || void 0 === _window ? void 0 : _window.location) && void 0 !== _window$location ? _window$location : {},
      protocol = _ref.protocol,
      hostname = _ref.hostname;
    return !getConfigValue("JUTRO_AUTH_HTTPS_LOCALHOST_SERVICE_WORKER", !1) && "https:" === protocol && ("localhost" === hostname || "127.0.0.1" === hostname);
  },
  buildUri = function (basename, suffix) {
    return joinUrl(window.location.origin, basename, suffix);
  };
export var getOidcConfiguration = function () {
  var _getConfigValue,
    basePath = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "",
    serviceWorkerDisabled = isServiceWorkerDisabled();
  serviceWorkerDisabled && warning("@jutro/auth service worker can be registered only for secure origins. You are running local https server, so session storage is used as fallback. If you want to test service worker in local https setup, you need to enable it explicitly by adding `REACT_APP_JUTRO_AUTH_HTTPS_LOCALHOST_SERVICE_WORKER=true` .env variable or switch to plain http.");
  var issuer = getConfigValue("JUTRO_AUTH_ISSUER"),
    authority_configuration = {
      authorization_endpoint: getConfigValue("JUTRO_AUTH_AUTHORIZATION_ENDPOINT"),
      token_endpoint: getConfigValue("JUTRO_AUTH_TOKEN_ENDPOINT"),
      revocation_endpoint: getConfigValue("JUTRO_AUTH_REVOCATION_ENDPOINT"),
      end_session_endpoint: getConfigValue("JUTRO_AUTH_END_SESSION_ENDPOINT"),
      userinfo_endpoint: getConfigValue("JUTRO_AUTH_USERINFO_ENDPOINT"),
      issuer: issuer
    },
    isManualAuthorityConfiguration = !_Object$values(authority_configuration).some(isUndefined),
    logoutTokensToInvalidate = getConfigValue("JUTRO_AUTH_LOGOUT_TOKENS_TO_INVALIDATE", "access_token,refresh_token").split(","),
    silentRedirectPath = getConfigValue("JUTRO_AUTH_SILENT_REDIRECT_PATH"),
    silentLoginPath = getConfigValue("JUTRO_AUTH_SILENT_LOGIN_PATH");
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread({
    authority: issuer,
    client_id: getConfigValue("JUTRO_AUTH_CLIENT_ID"),
    redirect_uri: buildUri(basePath, getConfigValue("JUTRO_AUTH_REDIRECT_PATH")),
    scope: null === (_getConfigValue = getConfigValue("JUTRO_AUTH_SCOPE")) || void 0 === _getConfigValue ? void 0 : _replaceAllInstanceProperty(_getConfigValue).call(_getConfigValue, ",", " "),
    refresh_time_before_tokens_expiration_in_second: 120
  }, silentRedirectPath && {
    silent_redirect_uri: buildUri(basePath, silentRedirectPath)
  }), silentLoginPath && {
    silent_login_uri: buildUri(basePath, silentLoginPath)
  }), {}, {
    service_worker_relative_url: serviceWorkerDisabled ? "" : testcafePolyfill(joinUrl(basePath, "OidcServiceWorker.js"))
  }, isManualAuthorityConfiguration && {
    authority_configuration: authority_configuration
  }), {}, {
    logout_tokens_to_invalidate: logoutTokensToInvalidate,
    silent_login_timeout: 12e4
  });
};